import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';
interface PassengerType {
	type: 'adults' | 'children' | 'infants';
	label: string;
	icon: string;
	description: string;
	min: number;
	max: number;
}

@Component({
	selector: 'app-passenger-selector',
	standalone: true,
	imports: [CommonModule, FormsModule, Toast],
	templateUrl: './PassengerSelector.component.html',
	styleUrls: ['./PassengerSelector.component.css'],
	providers: [MessageService]
})
export class PassengerSelectorComponent {
	private document = inject(DOCUMENT);
	private elementRef = inject(ElementRef);
	private messageService = inject(MessageService);
	isOpen = false;
	quieroAsiento = false;
	visiblePopupTipoPasajeros = false;
	visibleToastMax5Asiento = false;
	// Propiedad de salida para emitir cambios en passengers
	@Output() passengersChange = new EventEmitter<{
		adults: number;
		children: number;
		infants: number;
		quieroAsiento: boolean;
	}>();
	@Output() totalPasajeros = new EventEmitter<number>();
	passengers = {
		adults: 1,
		children: 0,
		infants: 0,
		quieroAsiento: false
	};
	passengerTypes: PassengerType[] = [
		{ type: 'adults', label: 'Adultos', icon: 'person', description: 'De 18 en adelante', min: 0, max: 5 },
		{
			type: 'children',
			label: 'Niños',
			icon: 'child_care',
			description: 'A partir de 5 hasta 17 años',
			min: 0,
			max: 5
		},
		{ type: 'infants', label: 'Bebés', icon: 'baby_changing_station', description: 'Menores de 5 años', min: 0, max: 5 }
	];
	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.isOpen = false;
		}
	}
	closeModalPasajeros() {
		this.isOpen = false;
		this.visiblePopupTipoPasajeros = false;
	}
	togglePopup() {
		this.isOpen = !this.isOpen;
		this.visiblePopupTipoPasajeros = true;
		this.adjustDropdownPosition();
	}
	onQuieroAsiento(event: Event) {
		const isChecked = (event.target as HTMLInputElement).checked;
		const total = this.totalPassengers;
		if (isChecked && total > 5) {
			(event.target as HTMLInputElement).checked = false;
			// this.totalPasajeros.emit(this.totalPassengers);
			if (!this.visibleToastMax5Asiento) {
				this.messageService.add({
					sticky: true,
					severity: 'warn',
					summary: 'Aviso',
					detail: 'Máximo 5 pasajeros con asientos.',
					key: 'br'
				});
				this.visibleToastMax5Asiento = true;
			}
			return;
		}
		this.quieroAsiento = isChecked;
		this.passengers['quieroAsiento'] = this.quieroAsiento;
		this.passengersChange.emit(this.passengers);
	}
	onReject() {
		this.messageService.clear('br');
		this.visibleToastMax5Asiento = false;
	}
	handlePassengerChange(type: 'adults' | 'children' | 'infants', increment: boolean) {
		const currentValue = this.passengers[type];
		const passengerType = this.passengerTypes.find((p) => p.type === type);
		if (passengerType) {
			if (increment) {
				const newValue = currentValue + 1;
				if (type === 'infants') {
					if (this.passengers.adults === 0) {
						alert('Los Bebés deben viajar acompañado por un adulto.');
						return;
					}
					if (this.passengers.quieroAsiento) {
						if (this.totalPassengers <= 4) {
							this.passengers[type] = Math.max(passengerType.min, Math.min(passengerType.max, newValue));
						}
					} else {
						this.passengers[type] = Math.max(passengerType.min, Math.min(passengerType.max, newValue));
					}
				} else {
					if (this.passengers.infants < 1) {
						if (this.totalPassengers <= 4) {
							this.passengers[type] = Math.max(passengerType.min, Math.min(passengerType.max, newValue));
						}
					} else {
						if (this.passengers.quieroAsiento) {
							if (this.totalPassengers <= 4) {
								this.passengers[type] = Math.max(passengerType.min, Math.min(passengerType.max, newValue));
							}
						} else {
							if (this.totalPassengers - this.passengers.infants <= 4) {
								this.passengers[type] = Math.max(passengerType.min, Math.min(passengerType.max, newValue));
							}
						}
					}
				}
			} else {
				const newValue = currentValue - 1;
				if (this.totalPassengers < 2) {
					alert('Debes seleccionar al menos un tipo de pasajero.');
					return;
				}
				if (type === 'adults') {
					if (this.passengers.adults < 2 && this.passengers.infants > 0) {
						alert('Los Bebés deben viajar acompañado por un adulto.');
						return;
					}
				}
				this.passengers[type] = Math.max(passengerType.min, Math.min(passengerType.max, newValue));
			}
		}
		this.passengersChange.emit(this.passengers);
	}
	adjustDropdownPosition() {
		const buttonRect = this.document.getElementById('seleccionar-pasajero');
		const dropdownRect = this.document.getElementById('dropdownContent');
		// const viewportHeight = window.innerHeight;
		const viewportHeight = this.document.documentElement.clientHeight;
		const viewportWidth = this.document.documentElement.clientWidth;
		const ss = buttonRect?.getBoundingClientRect();

		let topPosition = ss!.bottom + 310;
		let rightPosition = ss!.right + 261;
		if (this.document.getElementById('dropdownContent')) {
			if (viewportWidth > 560) {
				if (rightPosition > viewportWidth) {
					dropdownRect!.style.left = `-90px`;
				} else {
					dropdownRect!.style.removeProperty('right');
				}
			}
		}

		if (this.document.getElementById('dropdownContent')) {
			if (topPosition > viewportHeight) {
				dropdownRect!.style.top = `-290px`;
			} else {
				dropdownRect!.style.removeProperty('top');
			}
		}

		// this.dropdownContent.nativeElement.style.left = `${buttonRect.left + window.scrollX}px`;
	}
	@HostListener('window:scroll', [])
	onWindowScroll() {
		this.adjustDropdownPosition();
	}
	get totalPassengers(): number {
		return this.passengers.adults + this.passengers.children + this.passengers.infants;
	}

	onCheckboxChange(event: Event) {
		const inputElement = event.target as HTMLInputElement;
		this.quieroAsiento = inputElement.checked; // Cambia el valor de isChecked

		this.passengers['quieroAsiento'] = this.quieroAsiento;
		this.passengersChange.emit(this.passengers);
	}
}
